module.exports = __webpack_public_path__ + "static/media/sal.04d57c54.png";